module.exports = __webpack_public_path__ + "s.no2.db130b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/s.no2.jpg
// module id = sUUr
// module chunks = 0